export default "__VITE_ASSET__BKG14fg8__"